export enum LeadPriceType {
  CampaignGlobalPrice,
  KeywordPrice,
}
